import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
import Table from "../components/table"
import Paypal from "../components/paypal"
import DivWhite from "../components/divWhite"
import CalculCategorie from "../components/calculCategorie"
import MenuMember from "../components/menuMember"
import Button from "../components/button";
import HorizontalAlign from "../components/horizontalAlign";
import Text from "../components/text";
import Margin from "../components/margin";
import SelectInput from "../components/selectInput";

const RecapRenewal = props => {
    const [licences, setLicences] = useState(JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).licence))
    const [licencesWPrice, setLicencesWPrice] = useState([])
    const [club, setClub] = useState([])
    const [displayPaypal, setDisplayPaypal] = useState(false)
    const admin = localStorage.getItem('admin')
    const history = useHistory()
    const [total, setTotal] = useState(0)

    const getPrice = category => {
        if (category !== "OPEN" && category !== "VETERAN") return 20
        else return 30
    }

    useEffect(() => {
        let totalTmp = 0
        licencesWPrice.forEach(licence => {
            totalTmp += licence.price
        })
        setTotal(totalTmp)
        props.actions.licence.dispatchLicences(licencesWPrice)
    }, [licencesWPrice, props.actions.licence])

    useEffect(() => {
        const calculCost = () => {
            if (licences.length) {
                let arrayLicencesTmp = [], validite
                licences.forEach(licence => {
                    if (isNaN(parseInt(licence.validite)) || licence.validite < Date.now()) validite = new Date().getFullYear()
                    else validite = licence.validite

                    let category = CalculCategorie(licence.dateNaissance, new Date(`${validite}-09-01`))
                    const price = licence.typeLicence === 'subbuteo' ? 10 : getPrice(category)
                    arrayLicencesTmp.push({...licence, price})
                })
                setLicencesWPrice(arrayLicencesTmp)
            }
        }
        calculCost()
    }, [licences])

    const handleTypeLicence = (event, category, index) => {
        const licencesTmp = licencesWPrice
        const type = event.target.value
        let newPrice
        (type === "subbuteo") ? newPrice = 10 : newPrice = getPrice(category)
        licencesTmp[index].price = newPrice
        licencesTmp[index].typeLicence = type
        setLicencesWPrice([...licencesTmp])
    }

    useEffect(() => {
        const getData = async () => {
            setLicences(JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).licence))
            setClub(JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).club))
        }
        getData()
    }, [])

    return (
        <>
            <Navbar/>
            {(localStorage.getItem('admin') === 'true') ? <Menu/> : <MenuMember/>}
            <TitleH1 content="Récapitulatif de votre demande de renouvellement"/>
            <DivWhite content={
                <Table content={
                    <>
                        <thead>
                        <tr>
                            <td>Prénom & nom</td>
                            <td>Type de licence</td>
                            <td>Catégorie</td>
                            <td>Pour l'année</td>
                            <td>Prix</td>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            licencesWPrice.map((licence, index) => {
                                let validite
                                if (isNaN(parseInt(licence.validite)) || licence.validite < Date.now()) validite = new Date().getFullYear()
                                else validite = licence.validite
                                const category = CalculCategorie(licence.dateNaissance, new Date(`${validite}-09-01`))
                                return (
                                    <tr key={licence._id}>
                                        <td>{licence.prenom} {licence.nom}</td>
                                        <td>
                                            <SelectInput
                                                className="is-marginless"
                                                name="typeLicence"
                                                defaultValue={licence.typeLicence}
                                                onChange={(event) => handleTypeLicence(event, category, index)}
                                            >
                                                <option value="competition" name={index}>Compétition</option>
                                                <option value="subbuteo" name={index}>Subbuteo</option>
                                            </SelectInput>
                                        </td>
                                        <td>{category}</td>
                                        <td>{Date.now() > new Date(`07/01/${new Date().getFullYear()}`) ? new Date().getFullYear() + 1 : new Date().getFullYear()}</td>
                                        <td>{licence.price}€
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td colSpan="4"><b>TOTAL</b></td>
                            <td><b>{total}€</b></td>
                        </tr>
                        </tbody>
                    </>
                } width="100%"
                />
            } width="100%"/>

            <HorizontalAlign>
                <Button value="Tout est bon, je procède au paiement"
                        onClick={() => setDisplayPaypal(true)}/>
                {
                    admin === "true" ? <Button inverted={true} value="Sauter le paiement et renouveler"
                                               onClick={() => history.push("/confirm-renewal/licence")}/> : null
                }
            </HorizontalAlign>

            {displayPaypal ?
                <>
                    <Margin marginTop="64px"/>
                    <Text size="25px">Plusieurs moyens de paiement :</Text>
                    <Paypal
                        total={total}
                        name={club.nom}
                        description={"Renouvellement de licences"}
                        destination="/confirm-renewal/licence"
                        onSuccess={() => history.push("/confirm-renewal/licence")}
                    />
                </>
                : null
            }


        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(RecapRenewal)
